<template>
  <div>
    <ul
      v-for="(logoListArr, logoListDataKey) in logoListData"
      :key="'logoListData_' + logoListDataKey"
      class="d-flex logos"
    >
      <li
        v-for="(logoData, logoListKey) in logoListArr"
        :key="'logoListKey_' + logoListKey"
      >
        <img
          :src="logoData.link"
          :alt="logoData.alt || logoData.title"
          :title="logoData.title || logoData.alt"
        >
      </li>
    </ul>
  </div>
</template>
<script>
export default {
  name: 'LogoList',
  props: {
    logoListData: {
      required: true,
      type: Array,
    },
  },
};
</script>
